import { Button } from "@blueprintjs/core";
import type { IconName } from "@blueprintjs/icons";

type SidebarNavButtonProps = {
  icon: IconName;
  text: string;
  active?: boolean;
  trailingIcon?: IconName;
  onClick: () => void;
};

export function SidebarNavButton({
  icon,
  text,
  active = false,
  trailingIcon,
  onClick,
}: SidebarNavButtonProps) {
  return (
    <Button
      minimal
      fill
      alignText="left"
      icon={icon}
      rightIcon={trailingIcon}
      text={text}
      onClick={onClick}
      className={`h-9 px-2.5 rounded-md text-sm font-medium transition-colors ${
        active
          ? "bg-white/15 text-white"
          : "text-brand-paper/70 hover:bg-white/10 hover:text-white"
      }`}
    />
  );
}
